import { useBreakpointValue, useToast } from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { getLeadByExternalIdQueryKey } from '../../../../../../services/marketplace/generated/kubb/hooks/useGetLeadByExternalId';

export const useOfferActionFeedback = (externalId: string) => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const toastPosition = useBreakpointValue({ base: 'top', md: 'bottom' } as const) ?? 'bottom';

  const refetchOffers = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: getLeadByExternalIdQueryKey({ externalId }) });
  }, [queryClient, externalId]);

  const notifyOfferChanged = useCallback(() => {
    refetchOffers();
    toast({
      title: 'Something changed, refreshing',
      status: 'info',
      duration: 4000,
      isClosable: false,
      position: toastPosition,
    });
  }, [refetchOffers, toast, toastPosition]);

  return { refetchOffers, notifyOfferChanged };
};
